import styles from "../../styles/portfolioManagerDashboard.module.scss";
import GaugeChart from "./GaugeChart";
import KpiInfoIcon from "./KpiInfoIcon";
import { KPI_INFO } from "./kpiHelpers";


function PortfolioProjectsDonut({
  gaugeSegments
}) {


  return (
    <div className={styles.analyticsPanel}>
      <KpiInfoIcon content={KPI_INFO.projectsByStatus} />
      <div className={styles.pvHeader}>
        <div className={styles.pvKpiBlock}>
          <span className={styles.label}>Projects By Status</span>
        </div>
      </div>
      <div className={styles.pvBody}>
        <div className={styles.pvGaugeCol}>
          <GaugeChart
            size={230}
            showLegend
            {...(gaugeSegments ? { segments: gaugeSegments } : {})}
          />
        </div>
      </div>
    </div>
  );
}

export default PortfolioProjectsDonut;
